import React from "react";
import { TreeItemProps } from "@mui/lab";
import { IconLabelWrapper, IconTreeItem } from "./MapSidebar.style";

export const TreeIconItem = ({ label, ...rest }: TreeItemProps): JSX.Element => (
  <IconTreeItem label={<IconLabelWrapper>{label}</IconLabelWrapper>} {...rest} />
);
